import YxAutoComplete from './yx-auto-complete.vue';

export default {
  install(application) {
    application.component('yx-auto-complete', YxAutoComplete);
  },
};
